import styled from "@emotion/styled";

export const StyledTooltipBody = styled.div`
  color: ${(props) => props.theme.colors.grey};
  padding: 6px 0 0 0;
  font-size: 11px;
`;
